import { Link } from 'react-router-dom';
import styles from './PartnerAffiliatePromoStrip.module.css';

/** Sticky top banner for partner login / signup pages. */
export function PartnerAffiliatePromoStrip() {
  return (
    <div className={styles.strip} role="region" aria-label="LuvLust affiliate program">
      <p className={styles.text}>
        Get paid for every install you drive. Join hundreds of partners and start earning today!{' '}
        <span className={styles.minimum}>($10 minimum payout)</span>{' '}
        <Link className={styles.faqLink} to="/partners/faq">
          FAQ
        </Link>
      </p>
    </div>
  );
}
